import { z } from 'zod'
import { datetimeSchema } from './datetime'
import { SoftwareSchema } from './softwares'

export const LicenseSchema = z.object({
  id: z.number(),
  name: z.string(),
  license_key: z.string(),
  region_code: z.string(),
  software_id: z.number(),
  created_at: datetimeSchema,
  updated_at: datetimeSchema,
  activated_at: datetimeSchema.nullable(),
  expired_at: datetimeSchema.nullable(),
  software: SoftwareSchema.nullish(),
  software_version: z.string().nullable(),
  is_replaced: z.boolean(),
  availability_zone: z.string().nullable(),
  cloudformation_logical_name: z.string().nullable(),
  is_used: z.boolean()
})

export type License = z.infer<typeof LicenseSchema>
